// Listeners:
export var PAGE_ERROR = 'po-job.error';
export var POST_PAGE_ERROR = 'po-job-post-page-error';
export var PAGE_LOAD = 'po-job.page-load';
export var POJOB_ADD_SUCCESS = 'po-job-add-success';
export var POJOB_DELETE = 'po-job-delete';
export var POJOB_SETTINGS_TOGGLE = 'po-job-settings-toggle';
export var POJOB_TABLE_VIEW_ROWS = 'po-job-table-view-rows';
export var POJOB_PAGINATION = 'po-job-pagination';
export var POJOB_SORT = 'po-job-sort';
export var POJOB_MULTISELECT = 'po-job-multiselect';
export var POJOB_DELETE_SUCCESS = 'po-job-delete-success';
export var POJOB_VIEW_PURCHASES = 'po-job-view-purchases';
export var POJOB_SEARCH = 'po-job-search';
// Overlays:
export var POJOB_PAGE_OVERLAY = 'po-job-page';
export var POJOB_ADD_OVERLAY = 'po-job-add-overlay';
export var POJOB_DELETE_OVERLAY = 'po-job-delete-overlay';
export var PRO_ALLOWANCE_OVERLAY = 'pro-allowance-page';
export var PRO_ALLOWANCE_ASSIGN_OVERLAY = 'pro-allowance-assign-page';
// Pro Allowance:
export var PRO_PAGE_LOAD = 'pro-allowance.page-load';
export var PRO_GET_STARTED = 'pro-allowance.get-started';
export var PRO_GET_STATE = 'pro-allowance.get-state';
export var PRO_GET_ADD_USER = 'pro-allowance.add-user-click';
export var PRO_GET_CREATE_FLOW = 'pro-allowance.create-flow';
export var PRO_GET_FINISH_OVERLAY = 'pro-allowance.finish-overlay';
export var PRO_GET_CREATE_FREQUENCY = 'pro-allowance.get-create-frequency';
export var PRO_GET_INTERACTION_CLICK = 'pro-allowance.get-interaction-click';
export var PRO_GET_PAGE_LOAD_ERROR = 'pro-allowance.page-load-error';
export var PRO_GET_POST_PAGE_ERROR = 'pro-allowance.post-page-error';
export var PRO_GET_POPUP_OVERLAY = 'pro-allowance.get-popoverlay-click';
export var PRO_GET_ACTION_OVERLAY = 'pro-allowance.get-action-overlay-click';
export var PRO_TABLE_VIEW_ROWS = 'pro-allowance.table-view-rows';
export var PRO_GET_PAGINATION_CLICK = 'pro-allowance.get-view-pagination-click';
